module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "_idParaDest-7",
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st ParaOverride-10"
  }, [_c('a', {
    attrs: {
      "href": "#/eBook_V45578#_idTextAnchor001"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v("PART ONE")])]), _c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v(": The Infiltration")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st ParaOverride-11"
  }, [_c('span', {
    attrs: {
      "href": "#/eBook_V455720#_idTextAnchor193",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v("PART TWO")])]), _c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v(": The Fall of Hue")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st ParaOverride-11"
  }, [_c('span', {
    attrs: {
      "href": "#/eBook_V455726#_idTextAnchor320",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v("PART THREE")])]), _c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v(": Futility and Denial")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st ParaOverride-11"
  }, [_c('span', {
    attrs: {
      "href": "#/eBook_V455734#_idTextAnchor425",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v("PART FOUR")])]), _c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v(": Counterattack in "), _c('br'), _vm._v("the Triangle and Disaster at La Chu")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st ParaOverride-11"
  }, [_c('span', {
    attrs: {
      "href": "#/eBook_V455744#_idTextAnchor582",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v("PART FIVE")])]), _c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v(": Sweeping the Triangle")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st ParaOverride-11"
  }, [_c('span', {
    attrs: {
      "href": "#/eBook_V455755#_idTextAnchor768",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v("PART SIX")])]), _c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v(": Taking Back the Citadel")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st ParaOverride-11"
  }, [_c('span', {
    attrs: {
      "href": "#/eBook_V455769#_idTextAnchor986",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v("Epilogue")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st ParaOverride-11"
  }, [_c('span', {
    attrs: {
      "href": "#/eBook_V455770#_idTextAnchor1012",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v("Postscript")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st ParaOverride-11"
  }, [_c('span', {
    attrs: {
      "href": "#/eBook_V455771#_idTextAnchor1013",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st ParaOverride-11"
  }, [_c('span', {
    attrs: {
      "href": "#/eBook_V455772#_idTextAnchor1018",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v("Vietnamese Glossary")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st ParaOverride-11"
  }, [_c('span', {
    attrs: {
      "href": "#/eBook_V455773#_idTextAnchor1019",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v("Source Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st ParaOverride-12"
  }, [_c('span', {
    attrs: {
      "href": "#/eBook_V455774#_idTextAnchor1476",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "Map"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-4",
    attrs: {
      "alt": "",
      "src": "image/Map1Vietnamcopy.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17dbdb00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eBook_V45576.vue
// module id = 81
// module chunks = 0